const CYR_TO_LATIN = { а: "a", б: "b", е: "e", к: "k", м: "m", н: "h", о: "o", р: "p", с: "c", т: "t", х: "x", у: "y" };

export const normalizeSearch = str =>
  String(str ?? "")
    .toLowerCase()
    .split("")
    .map(ch => CYR_TO_LATIN[ch] ?? ch)
    .join("");
